// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 966 ? "login" : chunkId) + "." + {"48":"8f58f71d","71":"e8d7ab17","381":"5b41150f","394":"8f58f71d","415":"55fa5f84","527":"b526043f","722":"0a8224d0","767":"92dc79e8","892":"300e8717","966":"5f80b044"}[chunkId] + ".css";
};